import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'

import { type TollFreeStepsStore } from 'pages/settings/pages/compliance/pages/tollFree/store/tollFreeStepsStore'
import styles from './styles.module.scss'
import { CommonNumbers } from './CommonNumbers'

export type ICommonNumbersProps = {
  store: TollFreeStepsStore
  nextText: string
  nextHandler: () => void
}

export const CommonNumbersWithDesc = observer(
  ({ store, nextText, nextHandler }: ICommonNumbersProps) => {
    const {
      handleOpenIntercomWidget,
      stepLoading,
      numbersStore: { isInitialized, isStepDisabled },
    } = store

    if (!isInitialized) {
      return null
    }

    return (
      <div className={styles.wrap}>
        <PageDescription>
          Add all the toll-free numbers you want to verify. If you want to increase throughput on
          your toll-free numbers to send more messages,
          <Button
            text='contact us.'
            typeBtn='link'
            size='small'
            paddingInline={0}
            contained='secondary'
            className={styles.link}
            onClick={handleOpenIntercomWidget}
          />
        </PageDescription>

        <CommonNumbers
          loading={stepLoading}
          numbersStore={store.numbersStore}
          isLabelQuestionTooltip={false}
          labelText={'Unverified toll-free numbers'}
        />

        <NextButton
          loading={stepLoading}
          disabled={isStepDisabled || stepLoading}
          text={nextText}
          onClick={nextHandler}
        />
      </div>
    )
  }
)
